<template>
  <div class="points-details">
    <div class="tabs-content">
      <div class="tab-item" :class="{'active-item': tabActive === subItem.value}" v-for="subItem in tabsList" :key="subItem.value" @click="handleTabs(subItem)">{{ subItem.label }}</div>
    </div>
    <div v-if="tabActive === '2'" class="total-num">Balance：<span style="color: #ee541b;">{{ this.detailsInfo.integral }}</span></div>
    <div style="flex: 1; overflow-y: auto; min-height: 0;">
      <van-pull-refresh v-model="refreshing" @refresh="pullDownRefreshFn" style="min-height: 100%;">
        <van-list v-model="listLoading" :finished="finished" finished-text="There's nothing more！" offset="60" :immediate-check="false" @load="pullUpLoadMoreFn">
          <HistoryRecord v-if="tabActive === '1'" :showList="showList" />
          <MyPoints v-else-if="tabActive === '2'" :showList="showList" />
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="oper-btn">
      <!-- <div class="goback-btn" @click="toUrl">返回活动首页</div> -->
      <div class="goback-btn" @click="toUrl">Back to Event Home</div>
    </div>
  </div>
</template>

<script>
import { activityOrderAppListPageApi, activityEmployeeInfoApi } from '@/api'
import { Toast } from 'vant'
import { mapState } from 'vuex'
export default {
  name: 'PointsInfo',
  components: {
    HistoryRecord: () => import('./components/HistoryRecord'),
    MyPoints: () => import('./components/MyPoints')
  },
  data () {
    return {
      tabsList: [
        { label: 'History', value: '1' }, // 激励记录
        { label: 'My Points', value: '2' } // 账号管理
      ],
      tabActive: '1',
      refreshing: false,
      listLoading: false,
      finished: false,
      page: 1,
      detailsInfo: {},
      showList: []
    }
  },
  computed: {
    ...mapState({
      userInfo: 'myUserInfo'
    })
  },
  created () {
    if (this.$route.query.tabIndex) {
      this.tabActive = this.$route.query.tabIndex
    } else {
      this.tabActive = '1'
    }
    this.getInfo()
    this.getPointsData()
  },
  methods: {
    getPointsData () {
      this.listLoading = true
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      const data = {
        page: this.page,
        limit: 10,
        employeeId: this.userInfo.user.id
      }
      if (this.tabActive === '1') {
        data.orderTypeList = [0, 2, 3]
      } else if (this.tabActive === '2') {
        data.statusList = [10]
      }
      activityOrderAppListPageApi(data).then(res => {
        res.data.list.forEach(subItem => {
          subItem.fontColor = subItem.status === 10 ? '#ee541b' : subItem.status === 1 ? '#0db00b' : subItem.status === -1 ? '#c4200b' : subItem.status === 0 ? '#898989' : '#000'
        })
        if (this.page === 1) {
          this.showList = res.data.list
        } else {
          this.showList = [
            ...this.showList,
            ...res.data.list
          ]
        }
        this.listLoading = false
        this.page++
        if (this.showList.length === Number(res.data.totalRow)) {
          this.finished = true
        }
      }).catch(() => {
        this.listLoading = false
        this.finished = true
      }).finally(() => {
        Toast.clear()
        // 无论成功或失败，都关闭下拉刷新的加载动画
        this.refreshing = false
      })
    },
    getInfo () {
      activityEmployeeInfoApi(this.userInfo.user.id).then(res => {
        this.detailsInfo = res.data
      })
    },
    handleTabs (params) {
      this.tabActive = params.value
      this.pullDownRefreshFn()
    },
    pullDownRefreshFn () {
      this.page = 1
      this.showList = []
      this.finished = false
      this.getPointsData()
    },
    pullUpLoadMoreFn () {
      this.getPointsData()
    },
    toUrl () {
      this.$router.push('/activity')
    }
  }
}
</script>

<style lang="less" scoped>
.points-details {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
  font-size: 12px;
  overflow: hidden;
  .tabs-content {
    display: flex;
    align-items: center;
    padding: 16px 0;
    background-color: #fff;
    .tab-item {
      padding: 5px 26px;
      border: 1px solid #ee541b;
      color: #ee541b;
      font-weight: bold;
      font-size: 13px;
    }
    .active-item {
      color: #fff;
      background-color: #ee541b;
    }
  }
  .total-num {
    font-weight: bold;
    font-size: 16px;
    >span {
      font-size: 16px;
    }
  }
  .oper-btn {
    width: 100%;
    height: 80px;
    flex-shrink: 0;
    overflow: hidden;
    .goback-btn {
      width: 226px;
      height: 56px;
      margin: 0 auto;
      margin-top: 20px;
      text-align: center;
      line-height: 56px;
      font-size: 17px;
      font-weight: bold;
      color: #ee541b;
      border: 1px solid #ee541b;
      border-radius: 40px;
    }
  }
}
</style>
